import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";

import MainBottleInfo from "../MainBottleInfo";
import WineListsSidePanel from "../WineListsSidePanel";
import {
  trackingEvents,
  trackingEventViewedWineDetailsOptions,
  useTrackEvent,
} from "../../../helpers/Analytics";
import { GetWine_wine } from "../../../types/__generated__/GetWine";
import { MemberShoppingCart } from "../../../types/__generated__/MemberShoppingCart";
import { MemberRewardBasicInfo } from "../../../types/__generated__/MemberRewardBasicInfo";
import { Credit } from "../../../types/__generated__/Credit";

import {
  addWineToShoppingCartButtonStyle,
  infoBoxItemDescriptionHolderStyle,
  infoBoxItemDescriptionWrapperStyle,
  infoBoxItemProductHolderButtonsStyle,
  infoBoxItemProductHolderStyle,
  infoBoxItemStyle,
} from "./style";

interface BottleInfoTrayProps {
  wine: GetWine_wine | null | undefined;
  hasWineBeenReview: boolean;
  memberShoppingCartQuery: MemberShoppingCart | MemberRewardBasicInfo | null | undefined;
  handleToggleBottleInfoTray: Function;
  onReviewWineClick: Function;
  memberId?: number;
  isAddingAnother?: boolean;
  forceAddToBox?: boolean;
  isInBoxAndCartTray?: boolean;
  addBottleToCredit?: Credit;
  locationId?: number;
}

/**
 * Component for rendering Wine's details.
 */
const BottleInfoTray = ({
  wine,
  hasWineBeenReview,
  memberId,
  handleToggleBottleInfoTray,
  onReviewWineClick,
  memberShoppingCartQuery,
  isAddingAnother = false,
  forceAddToBox = false,
  isInBoxAndCartTray = false,
  addBottleToCredit,
  locationId,
}: BottleInfoTrayProps) => {
  const history = useHistory();
  const [isWineListsPanelOpen, setIsWineListsPanelOpen] = useState<boolean>(false);
  const trackEvent = useTrackEvent();

  useEffect(() => {
    trackEvent(trackingEvents.TRACKING_EVENT_VIEWED_WINE_DETAILS, {
      [trackingEventViewedWineDetailsOptions.WINE_SLUG]: wine?.product?.slug,
      [trackingEventViewedWineDetailsOptions.WINE_ID]: wine?.id,
    });
  }, []);

  /**
   * Toggles open/close of the wine lists panel.
   */
  const handleOffCanvasChange = () => {
    setIsWineListsPanelOpen(!isWineListsPanelOpen);
  };

  return (
    <>
      {isWineListsPanelOpen && (
        <WineListsSidePanel
          isInBoxAndCartTray={isInBoxAndCartTray}
          className="side-panel"
          handleOffCanvasChange={handleOffCanvasChange}
          memberId={memberId}
          wine={wine}
          history={history}
        />
      )}

      <MainBottleInfo
        wine={wine}
        hasWineBeenReview={hasWineBeenReview}
        memberShoppingCartQuery={memberShoppingCartQuery}
        handleOffCanvasChange={handleOffCanvasChange}
        handleToggleBottleInfoTray={handleToggleBottleInfoTray}
        onReviewWineClick={onReviewWineClick}
        infoBoxItemStyle={infoBoxItemStyle}
        addWineToShoppingCartButtonStyle={addWineToShoppingCartButtonStyle}
        infoBoxItemDescriptionHolderStyle={infoBoxItemDescriptionHolderStyle}
        infoBoxItemProductHolderButtonsStyle={infoBoxItemProductHolderButtonsStyle}
        infoBoxItemProductHolderStyle={infoBoxItemProductHolderStyle}
        infoBoxItemDescriptionWrapperStyle={infoBoxItemDescriptionWrapperStyle}
        isAddingAnother={isAddingAnother}
        forceAddToBox={forceAddToBox}
        isInBoxAndCartTray={isInBoxAndCartTray}
        isInSideTray
        memberId={memberId}
        addBottleToCredit={addBottleToCredit}
        locationId={locationId}
      />
    </>
  );
};

export default BottleInfoTray;
